import React from 'react';
import { WhatsappLogo, FacebookLogo, TwitterLogo, PinterestLogo, InstagramLogo, Link as LinkIcon } from '@phosphor-icons/react';
import { toast } from 'sonner';

const SocialShare = ({ product, url }) => {
  const shareUrl = url || window.location.href;
  const shareText = `Check out ${product?.name || 'this amazing jewelry'} at Luster Adorn!`;
  const imageUrl = product?.image_urls?.[0] || '';

  const handleInstagramShare = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      toast.success('Link copied! Now open Instagram and paste in your story or post.');
      // Optionally open Instagram app
      window.open('https://instagram.com/', '_blank');
    } catch (err) {
      toast.error('Failed to copy link');
    }
  };

  const shareLinks = [
    {
      name: 'WhatsApp',
      icon: WhatsappLogo,
      color: 'hover:bg-green-500',
      url: `https://wa.me/?text=${encodeURIComponent(shareText + ' ' + shareUrl)}`
    },
    {
      name: 'Instagram',
      icon: InstagramLogo,
      color: 'hover:bg-pink-600',
      action: handleInstagramShare,
      isButton: true
    },
    {
      name: 'Facebook',
      icon: FacebookLogo,
      color: 'hover:bg-blue-600',
      url: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`
    },
    {
      name: 'Twitter',
      icon: TwitterLogo,
      color: 'hover:bg-sky-500',
      url: `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(shareUrl)}`
    },
    {
      name: 'Pinterest',
      icon: PinterestLogo,
      color: 'hover:bg-red-600',
      url: `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(shareUrl)}&media=${encodeURIComponent(imageUrl)}&description=${encodeURIComponent(shareText)}`
    }
  ];

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      toast.success('Link copied to clipboard!');
    } catch (err) {
      toast.error('Failed to copy link');
    }
  };

  return (
    <div className="flex items-center gap-2">
      <span className="font-body text-sm text-text-secondary mr-2">Share:</span>
      {shareLinks.map((link) => (
        link.isButton ? (
          <button
            key={link.name}
            onClick={link.action}
            className={`w-9 h-9 rounded-full bg-background-subtle flex items-center justify-center text-text-secondary ${link.color} hover:text-white transition-all duration-200`}
            title={`Share on ${link.name}`}
          >
            <link.icon size={18} weight="fill" />
          </button>
        ) : (
          <a
            key={link.name}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            className={`w-9 h-9 rounded-full bg-background-subtle flex items-center justify-center text-text-secondary ${link.color} hover:text-white transition-all duration-200`}
            title={`Share on ${link.name}`}
          >
            <link.icon size={18} weight="fill" />
          </a>
        )
      ))}
      <button
        onClick={copyToClipboard}
        className="w-9 h-9 rounded-full bg-background-subtle flex items-center justify-center text-text-secondary hover:bg-primary hover:text-white transition-all duration-200"
        title="Copy link"
      >
        <LinkIcon size={18} />
      </button>
    </div>
  );
};

export default SocialShare;
